import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthAPI from "../api/authApi";
import { showError, showSuccess } from "../utils/toastUtils";
import { useLoader } from "../utils/LoaderUtils";
import { handleApiValidationError } from "../utils/apiErrorHandler";
import SubmitButton from "../components/partials/global/SubmitButton";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const { showLoader, hideLoader } = useLoader();
  const [isLoading, setIsLoading] = useState(false);

  const validate = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const newErrors = {};
    if (!email) {
      newErrors.email = "Email Address is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    showLoader();
    setIsLoading(true);

    e.preventDefault();

    if (!validate()) {
      setIsLoading(false);
      hideLoader();
      return;
    }

    try {
      const res = await AuthAPI.forgotPassword({ email });

      if (res.code === 200) {
        showSuccess(res.message);
        setEmail("");
      } else {
        showError(res.message);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      hideLoader();
      setIsLoading(false);
    }
  };

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper forgot-pass-wrap bg-img">
          <div className="login-content authent-content">
            <form method="post" onSubmit={handleSubmit}>
              <div className="login-userset">
                <div className="login-logo logo-normal">
                  <img
                    src={`${process.env.PUBLIC_URL}/img/logo.png`}
                    alt="img"
                  />
                </div>
                <Link to="/" className="login-logo logo-white">
                  <img
                    src={`${process.env.PUBLIC_URL}/img/logo.png`}
                    alt="img"
                  />
                </Link>
                <div className="login-userheading">
                  <h3>Forgot password?</h3>
                  <h4>
                    If you forgot your password, well, then we’ll email you
                    instructions to reset your password.
                  </h4>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Email Address<span className="text-danger"> *</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="email"
                      className="form-control border-end-0"
                      placeholder="Enter Email Address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <span className="input-group-text border-start-0">
                      <i className="ti ti-mail" />
                    </span>
                  </div>
                  {errors.email && (
                    <span className="errors text-danger">{errors.email}</span>
                  )}
                </div>
                
                <div className="form-login">
                  <SubmitButton
                    isLoading={isLoading}
                    text="Send Reset Link"
                    loadingText="Sending..."
                    className="w-100"
                  ></SubmitButton>
                </div>

                <div className="signinform text-center">
                  <h4>
                    Return to{" "}
                    <Link to="/" className="hover-a">
                      Login
                    </Link>
                  </h4>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
